import Hls from 'hls.js';

export const isHlsSupported = () => {
  return Hls.isSupported();
};
